module.exports = __webpack_public_path__ + "media/images/icons/vector-icon-4493670d877a6879688b11f812ae86ad.svg";